export default [
  {
    code: "395",
    description: "Moderate or heavy snow in area with thunder",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow_thunderstorm",
    night_icon: "wi_night_snow_thunderstorm"
  },
  {
    code: "392",
    description: "Patchy light snow in area with thunder",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet_storm",
    night_icon: "wi_night_sleet_storm"
  },
  {
    code: "389",
    description: "Moderate or heavy rain in area with thunder",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_thunderstorms",
    night_icon: "wi_night_thunderstorm"
  },
  {
    code: "386",
    description: "Patchy light rain in area with thunder",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_thunderstorms",
    night_icon: "wi_night_thunderstorm"
  },
  {
    code: "377",
    description: "Moderate or heavy showers of ice pellets",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet_storm",
    night_icon: "wi_night_sleet_storm"
  },
  {
    code: "374",
    description: "Light showers of ice pellets",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "371",
    description: "Moderate or heavy snow showers",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "368",
    description: "Light snow showers",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "365",
    description: "Moderate or heavy sleet showers",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "362",
    description: "Light sleet showers",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "359",
    description: "Torrential rain shower",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "356",
    description: "Moderate or heavy rain shower",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "353",
    description: "Light rain shower",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "350",
    description: "Ice pellets",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "338",
    description: "Heavy snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "335",
    description: "Patchy heavy snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "332",
    description: "Moderate snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "329",
    description: "Patchy moderate snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "326",
    description: "Light snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "323",
    description: "Patchy light snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "320",
    description: "Moderate or heavy sleet",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "317",
    description: "Light sleet",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "314",
    description: "Moderate or Heavy freezing rain",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "311",
    description: "Light freezing rain",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "308",
    description: "Heavy rain",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "305",
    description: "Heavy rain at times",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "302",
    description: "Moderate rain",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "299",
    description: "Moderate rain at times",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "296",
    description: "Light rain",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "293",
    description: "Patchy light rain",
    video_category: "Raiin",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "284",
    description: "Heavy freezing drizzle",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "281",
    description: "Freezing drizzle",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "266",
    description: "Light drizzle",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "263",
    description: "Patchy light drizzle",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_rain",
    night_icon: "wi_night_rain"
  },
  {
    code: "260",
    description: "Freezing fog",
    video_category: "Fog",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_fog",
    night_icon: "wi_night_fog"
  },
  {
    code: "248",
    description: "Fog",
    video_category: "Fog",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_fog",
    night_icon: "wi_night_fog"
  },
  {
    code: "230",
    description: "Blizzard",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow_thunderstorm",
    night_icon: "wi_night_snow_thunderstorm"
  },
  {
    code: "227",
    description: "Blowing snow",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_snow",
    night_icon: "wi_night_snow"
  },
  {
    code: "200",
    description: "Thundery outbreaks in nearby",
    video_category: "Thunderstorm",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_thunderstorm",
    night_icon: "wi_night_thunderstorm"
  },
  {
    code: "185",
    description: "Patchy freezing drizzle nearby",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_cloudy",
    night_icon: "wi_night_cloudy"
  },
  {
    code: "182",
    description: "Patchy sleet nearby",
    video_category: "RainSnowMix",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "179",
    description: "Patchy snow nearby",
    video_category: "Snow",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sleet",
    night_icon: "wi_night_sleet"
  },
  {
    code: "176",
    description: "Patchy rain nearby",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_showers",
    night_icon: "wi_night_showers"
  },
  {
    code: "143",
    description: "Mist",
    video_category: "Rain",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_haze",
    night_icon: "wi_night_haze"
  },
  {
    code: "122",
    description: "Overcast",
    video_category: "Cloudy",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_cloudy",
    night_icon: "wi_night_cloudy",
    video: "cloudy.mp4"
  },
  {
    code: "119",
    description: "Cloudy",
    video_category: "Cloudy",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_cloudy",
    night_icon: "wi_night_cloudy"
  },
  {
    code: "116",
    description: "Partly Cloudy",
    video_category: "Cloudy",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sunny",
    night_icon: "wi_night_clear"
  },
  {
    code: "113",
    description: "Clear/Sunny",
    video_category: "SunnyClear",
    video_day: "",
    video_night: "",
    day_icon: "wi_day_sunny",
    night_icon: "wi_night_clear"
  }
];
